<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />
    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement :info="basicRequirement" />
    <PositionSummary :info="positionInfo" />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../components/AssessmentIsa/AboutTheCompany.vue'
import TestimonialCompany from '../../components/AssessmentIsa/CompanyTestimonial.vue'
import Landing from '../../components/AssessmentIsa/LandingAssessment.vue'
import ProgramInfo from '../../components/AssessmentIsa/ProgramInfo.vue'
import Contact from '../../components/isaMain/Contact.vue'
import PositionSummary from '../../components/AssessmentIsa/PositionSummary.vue'
import BasicRequirement from '../../components/AssessmentIsa/BasicReq.vue'
import Faq from '../../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title1: 'Be an Executive brand acquisition',
        //   subTitle: 'Senior Marketing Executive (Contractual)',
        paragraph:
          'Take the assessment curated by Upskill and get a chance to work at dealdone, as a  business development PAID intern. salary 15,000- 20,000 BDT + + commission after 3 months probation',
        companyLogo: '',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/f917a228-14f9-452a-959c-fe36e4f2bf4f?public=true&job=BusinessDevelopmentDealdone',
        landingImage: require('../../assets/AssementLanding/Company_Logo/illustration.png'),
        spanColor: 'grey',
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: require('../../assets/AssementLanding/Company_Logo/rsz_1image_from_ios.png'),
        info:
          'DealDone is a Multichannel Order & Inventory Management software, that enables vendors to Connect Multiple Online Marketplace Stores to manage inventory in one place and have it synced across all connected channels.',
        designation: '',

        //   bgColor: '#DDEAFA',
        bgColor: 'white',
        txtColor: '#29292B',
      },
      programData: {
        headingInfo:
          'The assessment consists of 15 MCQS. You are required to pass the assessment test with a minimum of 60% of the total score. Top 5-10 Candidates will get the chance to go to the interview round after completing the assessment.',
        seatsInfo: '',
        startDate: '22nd March ',
        cost: 'Free',
        deadline: '8th April',

        bgColor: '#1EBCE5',
        txtColor: '#5277F7',
      },
      positionInfo: {
        //   paragraph:
        //     'This role is within the department Bongo Studios (www.bongostudios.com), which is the fastest-growing vertical within Bongo. Bongo Studios is a Multi-Channel Network (MCN) of a community of creative and independent content producers from multiple countries. We nurture talent and optimize content for our creators to help them achieve enhanced growth and monetization on multiple platforms (YouTube, Facebook, BongoBD, etc.). Currently, our creators reach over 180 million subscribers and have over 1.5 billion views per month.For this job role, we are looking for someone who is PMP certified and hassuccessfully managed a large team for at least 3 years, at a well-recognized company.The ideal candidate will be responsible for planning, coordinating, and managing the team within the timeline, budget, scope, and targets set for the department. They will also effectively monitor and present the updates to relevant stakeholders, clients, and team members.',
        //   remote: '',
        //   jobType: 'Job Type: Full-time ',
        //   txtColor: '#5277F7',
      },
      companyTestimonial: {
        //   mainImg: require('../assets/bongo/CTO_Bongo_Shadid 1.png'),
        //   name: 'Shadid Haque',
        //   paragraph:
        //     'At Bongo we believe in human-centric designs because people ignore design that ignores people. We are very excited to team up with Upskill in our mission to recruit the very best talents from all walks of life. We welcome anyone who wants to solve problems that impact millions of users and be part of a team that is empowered to do so.',
        //   designation: 'CTO  of Bongo',
        //   imgBg: '#DDEAFA',
        //   invertedCommaBg: '',
        //   firstComma: require('../assets/Canadian Tech company/“.svg'),
        //   secondComma: require('../assets/Canadian Tech company/Group 22.svg'),
      },
      basicRequirement: {
        mainContent: [
          'Three months Learning Internship Programme.',
          'Have to Move from one place to another',
          '      Attending Meetings',
          '      Negotiate/close deals and handle complaints or objections',

          'Collaborate with team members to achieve better results',
          'Collect regular marketing feedback with an objective to remain updated about the industry and provide strategic guidance for upgrading the market.',
          "Keep up-to-date information of competitor's products and ensure fair ,communication from customers to Management and Management to Customers.",
          'Negotiate/close deals and handle complaints or objections.',
          'Collaborate with team members to achieve better results.',
          'Build & promote strong, long-lasting customer relationships by partnering with them & understanding their needs.',
          'Make a presentation & proposal for the potential customers.',
        ],
        bgColor: '#184DBD',
      },

      outlineColor: {
        color: '#EA4424',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content: 'Yes, 4 years on backend developer\n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score i.e. 6 out of 10',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        //   {
        //     title: 'Will all the top 5 students get a job at Bongo?\n',
        //     content:
        //       'No, the top 5 students will get a chance to interview at Bongo, and will get the job depending on their performance in the interview.\n',
        //     category: 'FAQ',
        //   },
        {
          title: 'Salary?\n',
          content: '15k-20k +commission  \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
    PositionSummary,
  },
  created() {
    this.Loaded()
  },
}
</script>
